import React, { useState } from "react";
import Input from "componentsTemplate/Input/Input";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import NcLink from "componentsTemplate/NcLink/NcLink";
import Heading2 from "componentsTemplate/Heading/Heading2";
import Layout from "../layout";
import useAuth from "hooks/useAuth";
import { showToastError, showToastSuccess } from "utils/toasts";
import { useNavigate } from "react-router-dom";

const PageForgotPass = () => {

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [alreadySent, setAlreadySent] = useState(false);
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const navigate = useNavigate();
  const { forgetPassword } = useAuth();

  const sendEmail = async () => {
    setLoading(true);

    // valide o email com regex
    const regexEmail = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i;
    if (!email || email === '' || !regexEmail.test(email)) {
      showToastError("Por favor, informe um e-mail válido.");
      setLoading(false);
      return;
    }

    try {
      const response = await forgetPassword(email);

      if (response.status) {
        showToastSuccess("E-mail enviada com sucesso!");
        setAlreadySent(true);

        // leve o usuário para a tela de reset de senha com o email como parâmetro
        navigate(`/reset-password?email=${email}`);

        // window.location.reload();
      }

      setLoading(false);

    } catch (error) {
      showToastError("Essas credenciais não correspondem aos nossos registros.");
      setLoading(false);
    }
  };

  return (
    <Layout>
          <div className={alreadySent ? "hidden" : ""}>
            <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20">
              <Heading2>Alterar Senha</Heading2>
              <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
                Bem-vinda, por favor, informe seu e-mail para alterar sua senha.
              </span>
            </header>

            <div className="max-w-md mx-auto space-y-6">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Email
                  </span>
                  <Input
                    type="email"
                    placeholder="exemplo@exemplo.com"
                    className="mt-1"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>

                <div className="flex justify-center">
                  <ButtonPrimary className="mt-5" loading={loading} onClick={() => sendEmail()}>Continuar</ButtonPrimary>
                </div>
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                Voltar para {` `}
                <NcLink href="/login">Login</NcLink>
                {` / `}
                <NcLink href="/cadastro">Cadastro</NcLink>
              </span>
            </div>
          </div>

          {/* <div className={!alreadySent ? "hidden" : ""}>
            <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20">
              <Heading2>Definir Senha</Heading2>
              <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
                Bem-vinda, por favor, informe código enviado ao e-mail e a nova senha de acesso.
              </span>
            </header>

            <div className="max-w-md mx-auto space-y-6">

                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Código de Verificação
                  </span>
                  <Input
                    name="code"
                    defaultValue={""}
                    type="text"
                    placeholder="xxxxxx"
                    className="mt-1"
                    onChange={(e) => setCode(e.target.value)}
                  />
                </label>

                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Nova Senha
                  </span>
                  <Input
                    type="password"
                    placeholder="********"
                    className="mt-1"
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </label>

                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Confirmar Senha
                  </span>
                  <Input
                    type="password"
                    placeholder="********"
                    className="mt-1"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </label>

                <ButtonPrimary className="mt-5" loading={loading} onClick={() => valideCode()}>Continuar</ButtonPrimary>

              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                Voltar para {` `}
                <NcLink href="/login">Login</NcLink>
                {` / `}
                <NcLink href="/cadastro">Cadastro</NcLink>
              </span>
            </div>
          </div> */}
    </Layout>
  );
};

export default PageForgotPass;
